module.exports = __webpack_public_path__ + "static/media/heart-red.5d8dfeb8.svg";